<template>
  <div class="productsbox">
    <section id="banner">
      <div
        class="wrapper"
        :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"
      >
        <!-- <div class="inner_wrapper"> -->
        <!-- <fieldset>
            <legend>工业用闪存模块</legend>
            <div>
              <h2>领导业界之创新储存方案 更精实、更可靠</h2>
            </div>
        </fieldset>-->
        <!-- </div> -->
      </div>
    </section>
    <section id="breadcrumb" style="position: static; top: 0px;">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>
        &nbsp;&gt;&nbsp;{{categoryInfo.name}}&nbsp;&gt;&nbsp;
        <a>{{typeName}}</a>
      </div>
    </section>
    <section id="content">
      <div class="wrapper">
        <h1 id="uiLbl_Title" class="title">{{typeName}}</h1>
        <ul v-if="childTypeList && childTypeList.length > 0" class="titleul">
          <li
            v-for="(item, index) in childTypeList"
            :key="index"
            @click="gettitle(item.id)"
            :class="titletype==item.id?'active':''"
          >{{item.name}}</li>
          <!-- <li :class="titletype==2?'active':''" @click="gettitle(2)">定制版型</li> -->
          <!-- <li :class="titletype==3?'active':''" @click="gettitle(3)">定制功能</li> -->
        </ul>
        <div id="items">
          <div
            v-for="(item, index) in productList"
            :key="index"
            class="item"
            @click=" gotopro_detail(item.id)"
          >
            <a>
              <img :src="item.productPic" />
            </a>
            <div class="txt">
              <a>{{item.name}}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getProductList,
  queryProductType,
  getProductTypeByPid,
} from "@/api/product";
import { getCategoryInfo } from "@/api/content";
export default {
  name: "",
  data() {
    return {
      msg: "这是我的",
      categoryId: this.$route.query.categoryId,
      typeId: this.$route.query.typeId,
      productList: [],
      typeName: "",
      // categoryPic: ''
      categoryInfo: {},
      titletype: '',
      childTypeList: [],
      currentTypeId: null
    };
  },
  methods: {
    gotopro_detail(id) {
      this.$router.push({
        path: "/proDetail",
        query: { id: id, categoryId: this.categoryId },
      });
      window.location.reload();
    },
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then((res) => {
        if (res.code !== 200) return;
        this.categoryInfo = res.data;
        this.categoryInfo.categoryPic =
          process.env.BASE_API + "/web" + this.categoryInfo.categoryPic;
      });
    },
    getProductList() {
      let params = {
        size: 100,
        current: 1,
        productType: this.currentTypeId,
      };
      getProductList(params).then((res) => {
        if (res.code !== 200) return;
        let productList = res.data.records;
        productList.forEach((item) => {
          item.productPic = process.env.BASE_API + "/web" + item.productPic;
        });
        this.productList = productList;
      });
    },
    getProductTypeInfo() {
      queryProductType(this.typeId).then((res) => {
        if (res.code !== 200) return;
        this.typeName = res.data.name;
      });
    },
    gettitle(type) {
      this.titletype = type;
      this.currentTypeId = this.titletype
      this.getProductList()
    },
    getProductTypeByPid() {
      getProductTypeByPid(this.typeId).then((res) => {
        if (res.code !== 200) return;
        this.childTypeList = res.data;
        if (this.childTypeList && this.childTypeList.length > 0) {
          this.titletype = this.childTypeList[0].id
          this.currentTypeId = this.titletype
        } else {
          this.currentTypeId = this.typeId
        }
        this.getProductList()
      });
    },
  },
  mounted() {
    this.getBanner();
    this.getProductTypeInfo();
    this.getProductTypeByPid();
    // this.getProductList();
  },
  components: {},
};
</script>

<style scoped >
section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  .productsbox section#banner .wrapper {
    height: 160px;
  }
}
@media screen and (max-width: 1000px) {
  section#banner .wrapper {
    background-size: auto 100%;
  }
}
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
  /* background: ; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
@media screen and (max-width: 760px) {
  .productsbox section#banner .wrapper .inner_wrapper {
    width: 100%;
    height: 160px;
    padding: 10px;
  }
}
@media screen and (max-width: 1300px) {
  section#banner .wrapper .inner_wrapper {
    width: 100%;
  }
}
#banner .wrapper .inner_wrapper {
  width: 1280px;
  height: 312px;
  margin: auto;
  padding: 30px 40px 0;
  box-sizing: border-box;
  color: #fff;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper fieldset {
    border: 1px solid #fff;
    padding: 0 10px 10px;
    width: 220px;
  }
}
#banner .wrapper fieldset {
  border: 2px solid #fff;
  padding: 10px 30px 20px;
  width: 360px;
  box-sizing: border-box;
  text-align: left;
  font-family: "LatoWebBold";
}
@media screen and (max-width: 760px) {
  section#banner .wrapper fieldset legend {
    font-size: 12px;
  }
}
#banner .wrapper fieldset legend {
  font-family: "LatoWebBold";
  font-weight: normal;
  padding: 5px 10px;
  font-size: 19px;
  text-align: left;
  color: #fff;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper h2 {
    font-size: 16px;
  }
}
#banner .wrapper h2 {
  margin: 0;
  font-size: 26px;
  font-family: "LatoWeb";
  font-weight: normal;
}
#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}

@media screen and (max-width: 1300px) {
  section .wrapper {
    width: 100%;
  }
}
@media screen and (max-width: 1300px) {
  section .wrapper {
    width: 100%;
  }
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 1000px) {
  section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
  }
}
#content .wrapper {
  width: 960px;
  padding: 60px 0 100px;
  box-sizing: border-box;
}
@media screen and (max-width: 760px) {
  .productsbox section#content .wrapper .title {
    font-size: 30px;
    font-family: "LatoWebBold";
  }
}
#content .wrapper .title {
  font-size: 36px;
  color: #146cbd;
  padding: 20px 0 50px;
  font-family: "LatoWebBold";
}
#content .wrapper .titleul {
  margin-bottom: 30px;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
#content .wrapper .titleul li {
  float: left;
  width: 140px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  margin-left: 10px;
  background-color: #fff;
  border: 1px solid #146cbd;
  color: #146cbd;
}
#content .wrapper .titleul li.active {
  background-color: #146cbd;
  color: #fff;
}
#content .wrapper #items {
  margin: 0;
  text-align: left;
}
@media screen and (max-width: 760px) {
  .productsbox section#content .wrapper .item {
    display: inline-block;
    width: 48%;
    padding: 10px;
    margin-right: 2.4%;
    margin-bottom: 20px;
    box-sizing: border-box;
    vertical-align: top;
    border: 1px #c8c9ca solid;
    cursor: pointer;
    font-size: 18px;
    font-family: "LatoWebLight";
  }
}
@media screen and (max-width: 1000px) {
  section#content .wrapper .item {
    display: inline-block;
    width: 31%;
    padding: 10px;
    margin-right: 2.9%;
    margin-bottom: 20px;
    box-sizing: border-box;
    vertical-align: top;
    border: 1px #c8c9ca solid;
    cursor: pointer;
    font-size: 18px;
    font-family: "LatoWebLight";
  }
}
#content .wrapper .item {
  display: inline-block;
  width: 23.5%;
  padding: 10px;
  margin-right: 1%;
  margin-bottom: 20px;
  box-sizing: border-box;
  vertical-align: top;
  border: 1px #c8c9ca solid;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  font-family: "LatoWebLight";
}
#content .wrapper .item img {
  height: 150px;
}
@media screen and (max-width: 1000px) {
  #content .wrapper .item:nth-of-type(3n) {
    margin-right: 0;
  }
}
@media screen and (max-width: 760px) {
  section#content .wrapper .item:nth-of-type(2n),
  section#content .wrapper .item:nth-of-type(6n) {
    margin-right: 0 !important;
  }
}

@media screen and (max-width: 760px) {
  .products section#content .wrapper .item:nth-of-type(3n) {
    margin-right: 2.4%;
  }
}
#content .wrapper .item a {
  color: #15262e;
}
@media screen and (max-width: 1000px) {
  #content .wrapper .item img {
    margin: 0;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/products.vue